import { useEffect, useState } from 'react';
import { IExercise } from '../../../models/exercise';
import { Button } from '../../atoms/Button';
import { ListIcon, ChevronLeftIcon, ChevronRightIcon } from 'morpheus-ui';

interface ExercisePaginationProps {
  page: number;
  totalPages: number;
  currentExercise: IExercise;
  showContentList?: boolean;
  enableRevision?: boolean;
  isLoading?: boolean;
  onPrevious: () => void;
  onCheck: () => void;
  onNext: () => void;
  onEndRevision?: () => void;
  onClickContentList?: () => void;
}

export default function ExercisePagination({
  page,
  totalPages,
  currentExercise,
  showContentList = false,
  enableRevision = false,
  isLoading = false,
  onPrevious,
  onCheck,
  onNext,
  onEndRevision = () => {},
  onClickContentList = () => {},
}: ExercisePaginationProps) {
  const [innerWidth, setInnerWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (innerWidth < 992) {
    return (
      <footer
        className='
                font-noto fixed bottom-0 left-0
                flex h-20 w-full flex-row gap-xl
                border-t-hairline border-t-mono-color-lightest bg-color-lightest px-8 py-5
                shadow-level-2'
      >
        <Button
          variant='outlined'
          onClick={onPrevious}
          onlyIcon
          LeftIcon={ChevronLeftIcon}
          iconType='svg'
          disabled={page <= 0 || isLoading}
          classNameIcon='fill-button-color-tertiary-default'
        />
        {showContentList &&
        (currentExercise?.done || !currentExercise?.hasAlternativeSelected) ? (
          <Button
            LeftIcon={ListIcon}
            onClick={onClickContentList ?? (() => {})}
            variant='text'
            iconSize='large'
            className='flex-1 items-center justify-center'
            onlyIcon={innerWidth <= 390}
            iconType='svg'
            classNameIcon='fill-button-color-tertiary-default'
          >
            Lista de conteúdos
          </Button>
        ) : (
          <>
            {enableRevision ? (
              <Button
                onClick={onEndRevision}
                className='flex-1 items-center justify-center'
              >
                Finalizar revisão
              </Button>
            ) : (
              <Button
                onClick={onCheck}
                disabled={
                  !(
                    currentExercise?.hasAlternativeSelected &&
                    !currentExercise?.done
                  )
                }
                className='flex-1 items-center justify-center'
              >
                Conferir
              </Button>
            )}
          </>
        )}
        <Button
          variant='outlined'
          onlyIcon
          LeftIcon={ChevronRightIcon}
          iconType='svg'
          onClick={onNext}
          disabled={page >= totalPages - 1 || isLoading}
          classNameIcon='fill-button-color-tertiary-default'
        />
      </footer>
    );
  }

  return (
    <footer
      className='
                font-noto fixed bottom-0 left-0
                flex h-20 w-full flex-row gap-xl
                border-t-hairline border-t-mono-color-lightest bg-color-lightest px-8 py-5
                shadow-level-2'
    >
      <Button
        variant='outlined'
        onClick={onPrevious}
        disabled={page <= 0 || isLoading}
      >
        Exercício anterior
      </Button>
      {showContentList &&
      (currentExercise?.done || !currentExercise?.hasAlternativeSelected) ? (
        <Button
          LeftIcon='list'
          onClick={onClickContentList}
          variant='text'
          className='flex-1 items-center justify-center'
        >
          Lista de conteúdos
        </Button>
      ) : (
        <>
          {enableRevision ? (
            <Button
              onClick={onEndRevision}
              className='flex-1 items-center justify-center'
            >
              Finalizar revisão
            </Button>
          ) : (
            <Button
              onClick={onCheck}
              disabled={
                !(
                  currentExercise?.hasAlternativeSelected &&
                  !currentExercise?.done
                )
              }
              className='flex-1 items-center justify-center'
            >
              Conferir
            </Button>
          )}
        </>
      )}
      <Button
        variant='outlined'
        onClick={onNext}
        disabled={page >= totalPages - 1 || isLoading}
      >
        Próximo exercício
      </Button>
    </footer>
  );
}
